<mat-card *ngIf="responseOK">
  <h2>{{ 'signature.header.title.image' | translate }}</h2>
  <div class="content">
    <img alt="gracias" src="../../../../assets/img/gracias_por_confiar.png" />
  </div>
</mat-card>

<mat-card *ngIf="!responseOK">
  <h2>{{ 'request.header.title' | translate }} {{ numOperation }}</h2>
  <div class="content">
    <mat-icon class="icon-ic_circle_cross" color="accent"></mat-icon>
    <p class="title">{{ 'signature.response.cancel' | translate }}</p>
    <p>{{ 'signature.response.cancel.message' | translate }}</p>
  </div>
</mat-card>
